import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';

import $ from 'jquery';
import axios from 'axios';

import useAuth from '../../controllers/users/useAuth';
import HtmlParser from 'react-html-parser';
import {
    checkIfUserIsMaster, dataTableLanguaje, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, separatorsNumbersSet,
    numberSet, buttonProcessGet, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection, lodash,
} from '../../helpers/settings';

import Menu from '../main/Menu';

import ReconciliePaymentEditDetails from './ReconciliePaymentEditDetails';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import BuildingHeader from '../buildings/BuildingHeader';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { buildingModelGet } from '../../models/buildings/building';
import { collectionCashModelGet } from '../../models/collections/collectionCash';
import { userModelGet } from '../../models/users/user';
import { paymentMethodModelGet } from '../../models/paymentMethods/paymentMethod';
import { bankModelGet } from '../../models/banks/bank';
import { bankAccountModelGet } from '../../models/bankAccounts/bankAccount';
import { apartmentReceiptPaymentModelGet } from '../../models/payments/apartmentReceiptPayment';

const currentMethod = 'ReconcilePayments';

const { app, collections: dbColle, icons, labels, messages, } = globalSettings;
const { backend } = app;
const { properties: dbProps, } = dbColle;
const { operators: dbOpera, } = globalSettings?.react?.firebase;

const neutralValue = 0.00;

export default function ReconcilePayments({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    //const history = useHistory();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [processType, setProcessType] = useState(0);
    const [processTypeWindow, setProcessTypeWindow] = useState(0);
    const [showLoading, setShowLoading] = useState({ building: true, payments: true, });
    // const [showData, setShowData] = useState(false);
    const [headerSectionValues, setHeaderSectionValues] = useState(
        {
            levelOne: {
                colOne: {},
                colTwo: {},
                colThree: {
                    label: labels?.balance?.[languageObj?.id],
                    value: separatorsNumbersSet({
                        number: neutralValue,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    icon: icons?.moneyBillWave,
                    className: 'form-control bg-transparent text-black text-right',
                },
            }
        }
    );
    //#endregion variables

    //#region bank accounts
    const [bankAccountNumber, setBankAccountNumber] = useState('');
    //#endregion bank accounts

    //#region collection cashes
    const [collectionCashes, setCollectionCashes] = useState([collectionCashModelGet({})]);
    //#endregion collection cashes

    //#region buildings
    const buildingsId = 'buildingsId';
    const [buildingBalance, setBuildingBalance] = useState(neutralValue);
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    //#endregion buildings

    //#region apartment
    const [apartment, setApartment] = useState(apartmentModelGet({}));
    //#endregion apartment

    //#region payments
    const dtPaymentsId = 'dtPayments';

    const radioPaymentOneId = 'radioPaymentOne';
    const radioPaymentTwoId = 'radioPaymentTwo';
    const radioPaymentThreeId = 'radioPaymentThree';
    const radioPaymentName = 'radioPaymentName';

    const btnPaymentConditionOneId = 'btnPaymentConditionOne';
    const btnPaymentConditionTwoId = 'btnPaymentConditionTwo';
    const btnPaymentConditionThreeId = 'btnPaymentConditionThree';

    const [dtPaymentsRowIndex, setDtPaymentsRowIndex] = useState(0);
    const [payment, setPayment] = useState({});
    const [paymentBeforeEdit, setPaymentBeforeEdit] = useState({});
    const [paymentMethodDescription, setPaymentMethodDescription] = useState('');
    const [paymentShowModal, setPaymentShowModal] = useState(false);
    const [btnPaymentsSyncDisabled, setBtnPaymentsSyncDisabled] = useState(true);
    //#endregion payments

    //#region banks
    const [bankDescriptionOrigin, setBankDescriptionOrigin] = useState('');
    const [bankDescriptionDestiny, setBankDescriptionDestiny] = useState('');
    //#endregion banks

    //#region user (conciliation)
    const [userConciliation, setUserConciliation] = useState(userModelGet({}));
    //#endregion user (conciliation)

    //#region payments (methods)
    const dataTablePaymentsSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablePaymentsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtPaymentsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.date?.[languageObj?.id], orderable: false, searchable: false, visible: false, width: '0%', },
                    { title: labels?.type?.[languageObj?.id], width: '30%', },
                    { title: labels?.reference?.[languageObj?.id], width: '20%', },
                    { title: labels?.date?.[languageObj?.id], width: '20%', },
                    { title: labels?.amount?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '10%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtPaymentsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const paymentsGetAsync = async ({
        e = {},
        processType_ = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'paymentsGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                //e?.preventDefault();
            }

            //#region variables
            let dtRows = [];
            let buildingIdLocal = '';
            let paymetConcilationStatusLocal = '';
            let buildingBalanceLocal = neutralValue;
            let buildingLocal = buildingModelGet({});
            let paymentsLocal = [{
                amount: neutralValue,
                paymentMethodId: '',
                concilationStatus: '',
            }];
            const fasFaTagText = {
                success: `<i class='${icons?.fasFa?.tag} text-success'></i>`,
                warning: `<i class='${icons?.fasFa?.tag} text-warning'></i>`,
                primary: `<i class='${icons?.fasFa?.tag} text-primary'></i>`,
            };
            let paymentMethodLocal = paymentMethodModelGet({});
            let paymentMethodsLocal = [paymentMethodModelGet({})];
            //#endregion variables

            setShowLoading({ building: false, payments: true, });

            //#region dataTable clear
            response = await dataTablesClearAsync({
                dtPayments: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, payments: false, });
                return;
            }
            //#endregion dataTable clear

            //#region variables initialize
            dtRows = [];
            setBuilding({});
            setBuildingBalance(neutralValue);
            setProcessType(processType_);
            setPaymentMethodDescription('');
            setBtnPaymentsSyncDisabled(true);
            buildingIdLocal = $(`#${buildingsId}`)?.val();
            processType_ = (processType_ === 's' ? 1 : (processType_ === 'b' ? processType : processType_));

            headerSectionValues.levelOne.colThree.value = separatorsNumbersSet({
                number: neutralValue,
                withDecimals: true,
                consoleLogErrorShow: true,
                subMethod: currentMethod,
            })?.result;
            setHeaderSectionValues(headerSectionValues);

            //#region old code
            // response = await checkRadioControlSetAsync({
            //     rbAll: false,
            //     rbReconcilied: false,
            //     rbUnreconcilied: false,
            //     subMethod: currentMethod,
            // });

            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading({ building: false, payments: false, });
            //     return;
            // }
            //#endregion old code

            response = await checkRadioControlSetAsync({
                rbAll: processType_ === 0,
                rbUnreconcilied: processType_ === 1,
                rbReconcilied: processType_ === 2,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, payments: false, });
                return;
            }
            //#endregion variables initialize

            //#region payments get
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings?.find(({ id }) => id === buildingIdLocal) || {};
                if (!isUndNullEmp({ data: buildingLocal, subMethod: currentMethod, })?.result) {
                    setBuilding(buildingLocal);

                    dataObj = {
                        limit: 0,
                        ordersBy: [
                            { field: dbProps?.date, value: 'desc', }
                        ],
                        conditionals: [
                            { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingIdLocal, },
                        ],
                    };

                    switch (processType_) {
                        case 1:
                            dataObj?.conditionals?.push({ field: dbProps?.concilationStatus, operator: dbOpera?.notEqualTo, value: 'S' });
                            dataObj.ordersBy = [{ field: dbProps?.concilationStatus, value: 'asc', }];
                            dataObj?.ordersBy.push({ field: dbProps?.date, value: 'desc' });
                            break;
                        case 2:
                            dataObj?.conditionals?.push({ field: dbProps?.concilationStatus, operator: dbOpera?.equalTo, value: 'S' });
                            dataObj.ordersBy = [{ field: dbProps?.date, value: 'desc', }];
                            break;
                        default:
                            break;
                    }

                    dataObj.buildingId = buildingIdLocal;
                    dataObj.languageId = languageObj?.id;
                    dataObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentReceiptPayments}/`;

                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ building: false, payments: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    paymentMethodsLocal = response?.result?.paymentMethods || [];
                    paymentsLocal = response?.result?.apartmentReceiptPayments || [];

                    //#region old code
                    // if (!isUndNullEmp({ data: paymentsLocal, subMethod: currentMethod, })?.result && paymentsLocal?.length > 0) {
                    //     //#region methods payment
                    //     dataObj.limit = 0;
                    //     dataObj.conditionals = [];
                    //     dataObj.ordersBy = [
                    //         { field: dbProps?.description, value: 'asc', }
                    //     ];
                    //     dataObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlPaymentMethods}/`;

                    //     result = await axios?.post(
                    //         dataObj?.url,
                    //         dataObj,
                    //         headerObj,
                    //     );

                    //     response = result?.data || {};

                    //     if (!response?.isSuccess || response?.isWarning) {
                    //         setShowLoading({ building: false, payments: false, });
                    //         await sendMessageCloseCurrentWindowAsync({
                    //             msgType: response?.msgType,
                    //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    //             closeWindow: false,
                    //             urlGoTo: response?.urlGoTo,
                    //             auth: auth,
                    //             isLogout: false,
                    //             languageId: languageObj?.id,
                    //             subMethod: currentMethod,
                    //         });
                    //         return;
                    //     }
                    //     paymentMethodsLocal = response.result;

                    //     //#endregion methods payment
                    //     paymentsLocal?.forEach((detail) => {
                    //         //#region get payment method
                    //         paymentMethodLocal = paymentMethodsLocal?.find(({ id }) => id === detail?.paymentMethodId) || {};
                    //         //#endregion get payment method

                    //         //#region set status payment
                    //         paymetConcilationStatusLocal = detail?.concilationStatus === 'S' ?
                    //             fasFaTagText?.success :
                    //             detail?.concilationStatus === 'W' ?
                    //                 fasFaTagText?.warning :
                    //                 fasFaTagText?.primary;
                    //         //#endregion set status payment

                    //         //#region variables
                    //         dataObj = {
                    //             dateOrder: dateTimeFormatGlobalSet({
                    //                 date: detail?.date,
                    //                 type: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo,
                    //                 format: 24,
                    //                 addTime: false,
                    //                 secondsShow: false,
                    //                 languageId: languageObj?.id,
                    //                 subMethod: currentMethod,
                    //             })?.result,
                    //             status: `${paymetConcilationStatusLocal}${globalSettings?.html?.space?.formatOne}${paymentMethodLocal?.description}`,
                    //             reference: detail?.reference,
                    //             date: dateTimeFormatGlobalSet({
                    //                 date: detail?.date,
                    //                 type: languageObj?.format?.date?.f1,
                    //                 format: 0,
                    //                 addTime: false,
                    //                 secondsShow: false,
                    //                 languageId: languageObj?.id,
                    //                 subMethod: currentMethod,
                    //             })?.result,
                    //             amount: separatorsNumbersSet({
                    //                 number: numberSet({
                    //                     number: detail?.amount,
                    //                     type: 'd',
                    //                     languageId: languageObj?.id,
                    //                     subMethod: currentMethod,
                    //                 })?.result,
                    //                 withDecimals: true,
                    //                 consoleLogErrorShow: false,
                    //                 subMethod: currentMethod,
                    //             })?.result,
                    //         };
                    //         //#endregion variables

                    //         //#region methods
                    //         dtRows.push([
                    //             //#region old code
                    //             //dateTimeFormatGlobalSet(detail.date, globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo, 24, false).result,
                    //             //`${paymetConcilationStatusLocal}${globalSettings?.html?.space?.formatOne}${paymentMethodLocal.description}`,
                    //             //detail.reference,
                    //             //dateTimeFormatGlobalSet(detail.date, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0, false).result,
                    //             //separatorsNumbersSet(numberSet(detail.amount, 'd').result).result,
                    //             //#endregion old code
                    //             dataObj?.dateOrder,
                    //             dataObj?.status,
                    //             dataObj?.reference,
                    //             dataObj?.date,
                    //             dataObj?.amount,
                    //             buttonProcessGet({
                    //                 id: detail?.id,
                    //                 description: paymentMethodLocal?.description,
                    //                 showDetails: true,
                    //                 labelDetails: labels?.detail?.[languageObj?.id],
                    //                 enabledDetails: true,
                    //                 showEdit: true,
                    //                 labelEdit: labels?.reconcile?.[languageObj?.id],
                    //                 enabledEdit: processEvaluateGet({
                    //                     object: detail,
                    //                     property: labels?.process?.en?.toLowerCase(),
                    //                     process: labels?.edit?.en?.toLowerCase(),
                    //                     subMethod: currentMethod,
                    //                 })?.result,
                    //                 showDelete: false,
                    //                 labelDelete: labels?.delete?.[languageObj?.id],
                    //                 enabledDelete: false,
                    //                 processButtons: [],
                    //                 subMethod: currentMethod,
                    //             })?.result,
                    //         ]);
                    //         //#endregion methods
                    //     });

                    //     //#region building get balance
                    //     //setBuildingBalance(numberSet((sumBy(localPayments, 'amount')), 'd').result);
                    //     buildingBalanceLocal = numberSet({
                    //         number: lodash?.sum({ data: paymentsLocal, key: dbProps?.amount, subMethod: currentMethod, })?.result,
                    //         type: 'd',
                    //     })?.result
                    //     setBuildingBalance(buildingBalanceLocal);
                    //     headerSectionValues.levelOne.colThree.value = separatorsNumbersSet({
                    //         number: buildingBalanceLocal,
                    //         withDecimals: true,
                    //         consoleLogErrorShow: true,
                    //         subMethod: currentMethod,
                    //     })?.result;
                    //     setHeaderSectionValues(headerSectionValues);
                    //     //#endregion building get balance

                    //     setBtnPaymentsSyncDisabled(false);
                    // }
                    //#endregion old code

                    //#region dtRwos set
                    paymentsLocal?.forEach((detail) => {
                        //#region get payment method
                        paymentMethodLocal = paymentMethodsLocal?.find(({ id }) => id === detail?.paymentMethodId) || {};
                        //#endregion get payment method

                        //#region set status payment
                        paymetConcilationStatusLocal = detail?.concilationStatus === 'S' ?
                            fasFaTagText?.success :
                            detail?.concilationStatus === 'W' ?
                                fasFaTagText?.warning :
                                fasFaTagText?.primary;
                        //#endregion set status payment

                        //#region variables
                        dataObj = {
                            dateOrder: dateTimeFormatGlobalSet({
                                date: detail?.date,
                                type: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo,
                                format: 24,
                                addTime: false,
                                secondsShow: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            status: `${paymetConcilationStatusLocal}${globalSettings?.html?.space?.formatOne}${paymentMethodLocal?.description}`,
                            reference: detail?.reference,
                            date: dateTimeFormatGlobalSet({
                                date: detail?.date,
                                type: languageObj?.format?.date?.f1,
                                format: 0,
                                addTime: false,
                                secondsShow: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            amount: separatorsNumbersSet({
                                number: numberSet({
                                    number: detail?.amount,
                                    type: 'd',
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result,
                                withDecimals: true,
                                consoleLogErrorShow: false,
                                subMethod: currentMethod,
                            })?.result,
                        };
                        //#endregion variables

                        //#region methods
                        dtRows.push([
                            //#region old code
                            //dateTimeFormatGlobalSet(detail.date, globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo, 24, false).result,
                            //`${paymetConcilationStatusLocal}${globalSettings?.html?.space?.formatOne}${paymentMethodLocal.description}`,
                            //detail.reference,
                            //dateTimeFormatGlobalSet(detail.date, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0, false).result,
                            //separatorsNumbersSet(numberSet(detail.amount, 'd').result).result,
                            //#endregion old code
                            dataObj?.dateOrder,
                            dataObj?.status,
                            dataObj?.reference,
                            dataObj?.date,
                            dataObj?.amount,
                            buttonProcessGet({
                                id: detail?.id,
                                description: paymentMethodLocal?.description,
                                showDetails: true,
                                labelDetails: labels?.detail?.[languageObj?.id],
                                enabledDetails: true,
                                showEdit: true,
                                labelEdit: labels?.reconcile?.[languageObj?.id],
                                enabledEdit: processEvaluateGet({
                                    object: detail,
                                    property: labels?.process?.en?.toLowerCase(),
                                    process: labels?.edit?.en?.toLowerCase(),
                                    subMethod: currentMethod,
                                })?.result,
                                showDelete: false,
                                labelDelete: labels?.delete?.[languageObj?.id],
                                enabledDelete: false,
                                processButtons: [],
                                subMethod: currentMethod,
                            })?.result,
                        ]);
                        //#endregion methods
                    });
                    //#endregion dtRwos set

                    //#region building get balance
                    buildingBalanceLocal = numberSet({
                        number: lodash?.sum({ data: paymentsLocal, key: dbProps?.amount, subMethod: currentMethod, })?.result,
                        type: 'd',
                    })?.result
                    setBuildingBalance(buildingBalanceLocal);
                    headerSectionValues.levelOne.colThree.value = separatorsNumbersSet({
                        number: buildingBalanceLocal,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result;
                    setHeaderSectionValues(headerSectionValues);
                    //#endregion building get balance

                    setBtnPaymentsSyncDisabled(false);

                    //#region old code
                    // response = await checkRadioControlSetAsync({
                    //     rbAll: processType_ === 0,
                    //     rbUnreconcilied: processType_ === 1,
                    //     rbReconcilied: processType_ === 2,
                    //     subMethod: currentMethod,
                    // });

                    // if (!response?.isSuccess || response?.isWarning) {
                    //     setShowLoading({ building: false, payments: false, });
                    //     return;
                    // }
                    //#endregion old code
                }
            }
            //#endregion payments get

            //#region data in dataTable set
            $(`#${dtPaymentsId}`)?.DataTable()?.rows?.add(dtRows)?.draw();
            //#endregion data in dataTable set

            setShowLoading({ building: false, payments: false, });
        } catch (ex) {
            setShowLoading({ building: false, payments: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const paymentGetAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        processType_ = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'paymentGetAsync';
        let response = responseGet();
        try {
            //#region variables
            //let buildingIdLocal = '';
            let banksLocal = [bankModelGet({})];
            let apartmentLocal = apartmentModelGet({});
            let bankAccountsLocal = [bankAccountModelGet({})];
            let paymentLocal = apartmentReceiptPaymentModelGet({});
            //let collectionCashesLocal = [collectionCashModelGet({})];
            //#endregion variables

            setShowLoading({ building: false, payments: true, });

            //#region initialize
            setPayment({});
            setApartment('');
            setCollectionCashes([]);
            setPaymentBeforeEdit({});
            setBankDescriptionOrigin('');
            setBankDescriptionDestiny('');
            setDtPaymentsRowIndex(rowIndex);
            setPaymentMethodDescription('');
            //buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion initialize

            //#region old code
            // //#region payment get
            // // headerObj = {
            // //     headers: {
            // //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            // //         languageId: languageObj?.id,
            // //     },
            // //     url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentReceiptPayments}/${id}`,
            // // };

            // // result = await axios?.get(
            // //     headerObj?.url,
            // //     headerObj,
            // // );

            // // response = result?.data || {};

            // // if (!response?.isSuccess || response?.isWarning) {
            // //     setShowLoading({ building: false, payments: false, });
            // //     await sendMessageCloseCurrentWindowAsync({
            // //         msgType: response?.msgType,
            // //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            // //         closeWindow: false,
            // //         urlGoTo: response?.urlGoTo,
            // //         auth: auth,
            // //         isLogout: false,
            // //         languageId: languageObj?.id,
            // //         subMethod: currentMethod,
            // //     });
            // //     return;
            // // }

            // // paymentLocal = response?.result || {};
            // // setPayment(paymentLocal);
            // // setPaymentBeforeEdit(paymentLocal);
            // //#endregion payment get

            // //#region userReconciliation get
            // // if (!isUndNullEmp({ data: paymentLocal?.concilationDate, subMethod: currentMethod, })?.result &&
            // //     !isUndNullEmp({ data: paymentLocal?.concilationStatus, subMethod: currentMethod, })?.result &&
            // //     !isUndNullEmp({ data: paymentLocal?.conciliationUserId, subMethod: currentMethod, })?.result &&
            // //     paymentLocal.concilationStatus === 'S') {
            // //     headerObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${paymentLocal?.conciliationUserId}`;
            // //     result = await axios?.get(
            // //         headerObj?.url,
            // //         headerObj,
            // //     );

            // //     response = result?.data || {};

            // //     if (!response?.isSuccess || response?.isWarning) {
            // //         setShowLoading({ building: false, payments: false, });
            // //         await sendMessageCloseCurrentWindowAsync({
            // //             msgType: response?.msgType,
            // //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            // //             closeWindow: false,
            // //             urlGoTo: response?.urlGoTo,
            // //             auth: auth,
            // //             isLogout: false,
            // //             languageId: languageObj?.id,
            // //             subMethod: currentMethod,
            // //         });
            // //         return;
            // //     }

            // //     setUserConciliation(response?.result || {});
            // // }
            // //#endregion userReconciliation get

            // //#region collectionCashes get
            // // if (isUndNullEmp({ data: paymentLocal?.collectionCashId, subMethod: currentMethod, })?.result &&
            // //     isUndNullEmp({ data: paymentLocal?.bankId, subMethod: currentMethod, })?.result &&
            // //     isUndNullEmp({ data: paymentLocal?.bankAccountId, subMethod: currentMethod, })?.result) {
            // //     response = await validationCollectionCashGetAsync({
            // //         buildingId: buildingIdLocal,
            // //         limit: 0,
            // //         auth: auth,
            // //         languageId: languageObj?.id,
            // //         subMethod: currentMethod,
            // //     });

            // //     if (!response?.isSuccess || response?.isWarning) {
            // //         setShowLoading({ building: false, payments: false, });
            // //         await sendMessageCloseCurrentWindowAsync({
            // //             msgType: response?.msgType,
            // //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            // //             closeWindow: false,
            // //             urlGoTo: response?.urlGoTo,
            // //             auth: auth,
            // //             isLogout: false,
            // //             languageId: languageObj?.id,
            // //             subMethod: currentMethod,
            // //         });
            // //         return;
            // //     }

            // //     collectionCashesLocal = response?.result || [];
            // //     setCollectionCashes(collectionCashesLocal);
            // // }
            // //#endregion collectionCashes get

            // //#region bankAccounts get
            // // if (!isUndNullEmp({ data: paymentLocal?.bankId, subMethod: currentMethod, })?.result &&
            // //     !isUndNullEmp({ data: paymentLocal?.bankAccountId, subMethod: currentMethod, })?.result) {
            // //     response = await validationBankAccountGetAsync({
            // //         buildingId: buildingIdLocal,
            // //         limit: 0,
            // //         auth: auth,
            // //         languageId: languageObj?.id,
            // //         subMethod: currentMethod,
            // //     });

            // //     if (!response?.isSuccess || response?.isWarning) {
            // //         setShowLoading({ building: false, payments: false, });
            // //         await sendMessageCloseCurrentWindowAsync({
            // //             msgType: response?.msgType,
            // //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            // //             closeWindow: false,
            // //             urlGoTo: response?.urlGoTo,
            // //             auth: auth,
            // //             isLogout: false,
            // //             languageId: languageObj?.id,
            // //             subMethod: currentMethod,
            // //         });
            // //         return;
            // //     }

            // //     bankAccountsLocal = response?.result || [];
            // //     setBankAccountNumber(bankAccountsLocal?.find(({ id }) => id === paymentLocal?.bankAccountId)?.number || {});
            // // }
            // //#endregion bank accounts)

            // //#region banks get
            // // if (!isUndNullEmp({ data: paymentLocal?.bankId, subMethod: currentMethod, })?.result) {
            // //     response = await validationBankGetAsync({
            // //         buildingId: buildingIdLocal,
            // //         limit: 0,
            // //         auth: auth,
            // //         languageId: languageObj?.id,
            // //         subMethod: currentMethod,
            // //     });

            // //     if (!response?.isSuccess || response?.isWarning) {
            // //         setShowLoading({ building: false, payments: false, });
            // //         await sendMessageCloseCurrentWindowAsync({
            // //             msgType: response?.msgType,
            // //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            // //             closeWindow: false,
            // //             urlGoTo: response?.urlGoTo,
            // //             auth: auth,
            // //             isLogout: false,
            // //             languageId: languageObj?.id,
            // //             subMethod: currentMethod,
            // //         });
            // //         return;
            // //     }

            // //     banksLocal = response?.result || [];

            // //     setBankDescriptionOrigin(banksLocal?.find(({ id }) => id === paymentLocal?.bankOriginId)?.description || '');
            // //     setBankDescriptionDestiny(banksLocal?.find(({ id }) => id === paymentLocal?.bankId)?.description || '');
            // // }
            // //#endregion banks get

            // //#region apartment get
            // // headerObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlApartments}/${paymentLocal?.apartmentId}`
            // // result = await axios?.get(
            // //     headerObj?.url,
            // //     headerObj,
            // // );

            // // response = result?.data || {};

            // // if (!response?.isSuccess || response?.isWarning) {
            // //     setShowLoading({ building: false, payments: false, });
            // //     await sendMessageCloseCurrentWindowAsync({
            // //         msgType: response?.msgType,
            // //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            // //         closeWindow: false,
            // //         urlGoTo: response?.urlGoTo,
            // //         auth: auth,
            // //         isLogout: false,
            // //         languageId: languageObj?.id,
            // //         subMethod: currentMethod,
            // //     });
            // //     return;
            // // }

            // // apartmentLocal = response?.result || {};
            // // setApartment(apartmentLocal);
            // //#endregion apartment get
            //#endregion old code

            //#region date get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                apartmentReceiptPaymentId: id,
                method: backend?.methods?.reconciliePaymentDataGet,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentReceiptPayments}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            dataObj = response?.result;
            banksLocal = dataObj?.banks || []
            bankAccountsLocal = dataObj?.bankAccounts || []
            paymentLocal = dataObj?.apartmentReceiptPayment || {}
            setPayment(paymentLocal);
            setApartment(apartmentLocal);
            setPaymentBeforeEdit(paymentLocal);
            setUserConciliation(dataObj?.userConciliation || {});
            setCollectionCashes(dataObj?.collectionCashes || []);
            setBankAccountNumber(bankAccountsLocal?.find(({ id }) => id === paymentLocal?.bankAccountId)?.number || {});
            setBankDescriptionOrigin(banksLocal?.find(({ id }) => id === paymentLocal?.bankOriginId)?.description || '');
            setBankDescriptionDestiny(banksLocal?.find(({ id }) => id === paymentLocal?.bankId)?.description || '');
            //#endregion date get

            //#region data set
            setProcessType((await checkRadioControlGetAsync({}))?.result);
            setProcessTypeWindow(processType_);
            setPaymentMethodDescription(description);
            //#endregion data set

            setPaymentShowModal(true);
            setShowLoading({ building: false, payments: false, });
        } catch (ex) {
            setShowLoading({ building: false, payments: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion payments (methods)

    //#region methods (others)
    const dataGetAsync = async ({
        subMethod = ''
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, payments: true, });

            //#region variables initialize
            setBuildings([]);
            setBtnPaymentsSyncDisabled(true);
            //#endregion variables initialize

            //#region dataTables set
            response = await dataTablesSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, payments: false, });
                return;
            }
            //#endregion dataTables set

            //#region buildings get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlReconcilePayments,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion buildings get

            setShowLoading({ building: false, payments: false, });
        } catch (ex) {
            setShowLoading({ building: false, payments: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            response = await dataTablePaymentsSetAsync({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = await queryCodeSetAsync({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region payments
            $(`#${dtPaymentsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtPaymentsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value;
                    method = e?.target?.attributes?.method?.value;
                    description = e?.target?.attributes?.description?.value;
                    switch (method) {
                        case 'details':
                            paymentGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType_: 0, subMethod: currentMethod, });
                            break;
                        case 'edit':
                            paymentGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType_: 1, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion payments

            //#region payments (condition)
            $(`#${radioPaymentOneId}`)?.on('click', function (e) {
                if (e?.target?.checked) {
                    $(`#${btnPaymentConditionOneId}`)?.trigger('click');
                }
            });

            $(`#${radioPaymentTwoId}`)?.on('click', function (e) {
                if (e?.target?.checked) {
                    $(`#${btnPaymentConditionTwoId}`)?.trigger('click');
                }
            });

            $(`#${radioPaymentThreeId}`)?.on('click', function (e) {
                if (e?.target?.checked) {
                    $(`#${btnPaymentConditionThreeId}`)?.trigger('click');
                }
            });
            //#endregion payments (condition)
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesClearAsync = async ({
        dtPayments = false,
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            if (dtPayments) {
                $(`#${dtPaymentsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const checkRadioControlSetAsync = async ({
        rbAll = false,
        rbUnreconcilied = false,
        rbReconcilied = false,
        subMethod = '',
    }) => {
        const currentMethod = 'checkRadioControlSetAsync';
        let response = responseGet();
        try {
            const falseState = false;
            $(`#${radioPaymentOneId}`).prop({ checked: falseState });
            $(`#${radioPaymentTwoId}`).prop({ checked: falseState, });
            $(`#${radioPaymentThreeId}`).prop({ checked: falseState, });

            $(`#${radioPaymentOneId}`).prop({ checked: rbAll, });
            $(`#${radioPaymentTwoId}`).prop({ checked: rbUnreconcilied, });
            $(`#${radioPaymentThreeId}`).prop({ checked: rbReconcilied, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const checkRadioControlGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'checkRadioControlSetAsync';
        let response = responseGet();
        try {

            if ($(`#${radioPaymentOneId}`).prop('checked')) {
                response.result = 0;
            } else if ($(`#${radioPaymentTwoId}`).prop('checked')) {
                response.result = 1;
            } else if ($(`#${radioPaymentThreeId}`).prop('checked')) {
                response.result = 2;
            }
        } catch (ex) {
            response.result = -1;
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
    }, [auth]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='collection' process='reconcilePayments' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <section className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.reconcilePayments?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.reconcilePayments?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>

                                {/*buildings*/}
                                <BuildingHeader buildingsId={buildingsId}
                                    building={building}
                                    buildings={buildings}
                                    btnSyncDisabled={btnPaymentsSyncDisabled}
                                    methodGetAsync={paymentsGetAsync}
                                    processType={0}
                                    headerSectionValues={headerSectionValues}
                                    showLoading={showLoading?.building}
                                    languageObj={languageObj} />

                                {/*payments*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.payments}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.reconcilePayments?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.reconcilePaymentsLogo}></img> - {labels?.reconcilePayments?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-3 text-muted'>
                                                <div className='form-group'>
                                                    <label>{labels?.condition?.[languageObj?.id]}:</label>
                                                </div>
                                            </div>
                                            <div className='col-md-3 text-muted'>
                                                <div className='form-group'>
                                                    <div className='icheck-primary d-inline'>
                                                        <input type='radio' disabled={isUndNullEmp({ data: building?.id, subMethod: '' })?.result} id={radioPaymentOneId} name={radioPaymentName} />
                                                        <label htmlFor={radioPaymentOneId}>{labels?.all?.[languageObj?.id]}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-3 text-muted'>
                                                <div className='form-group'>
                                                    <div className='icheck-primary d-inline'>
                                                        <input type='radio' disabled={isUndNullEmp({ data: building?.id, subMethod: '' })?.result} id={radioPaymentTwoId} name={radioPaymentName} />
                                                        <label htmlFor={radioPaymentTwoId}>{labels?.unreconciled?.[languageObj?.id]}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-3 text-muted'>
                                                <div className='form-group'>
                                                    <div className='icheck-primary d-inline'>
                                                        <input type='radio' disabled={isUndNullEmp({ data: building?.id, subMethod: '' })?.result} id={radioPaymentThreeId} name={radioPaymentName} />
                                                        <label htmlFor={radioPaymentThreeId}>{labels?.conciled?.[languageObj?.id]}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row' hidden>
                                            <div className='form-group text-right'>
                                                <button className='btn btn-outline-info mx-1'
                                                    disabled={isUndNullEmp({ data: building?.id, subMethod: 'btn - all' })?.result}
                                                    id={btnPaymentConditionOneId}
                                                    onClick={(e) => paymentsGetAsync({ e: e, processType_: 0, subMethod: 'btn - all', })} >
                                                    <i className={icons?.listOl}></i>
                                                </button>
                                                <button className='btn btn-outline-warning mx-1'
                                                    disabled={isUndNullEmp({ data: building?.id, subMethod: 'btn - noConcilied', })?.result}
                                                    id={btnPaymentConditionTwoId}
                                                    onClick={(e) => paymentsGetAsync({ e: e, processType_: 1, subMethod: 'btn - noConcilied', })} >
                                                    <i className={icons?.sortNumericUpAlt}></i>
                                                </button>
                                                <button className='btn btn-outline-success mx-1'
                                                    disabled={isUndNullEmp({ data: building?.id, subMethod: 'btn - concilied', })?.result}
                                                    id={btnPaymentConditionThreeId}
                                                    onClick={(e) => paymentsGetAsync({ e: e, processType_: 2, subMethod: 'btn - concilied', })} >
                                                    <i className={icons?.sortNumericDown}></i>
                                                </button>
                                            </div>

                                        </div>

                                        <div className='row'>
                                            <div className='col-md-3'>
                                                <div className='form-group text-muted'>
                                                    <b>{labels?.legend?.[languageObj?.id]}</b>
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='form-group text-muted'>
                                                    {HtmlParser(`<i class='fas fa-tag text-warning'></i>${globalSettings?.html?.space?.formatOne}${labels?.correct?.[languageObj?.id]}`)}
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='form-group text-muted'>
                                                    {HtmlParser(`<i class='fas fa-tag text-primary'></i>${globalSettings?.html?.space?.formatOne}${labels?.unreconciled?.[languageObj?.id]}`)}
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='form-group text-muted'>
                                                    {HtmlParser(`<i class='fas fa-tag text-success'></i>${globalSettings?.html?.space?.formatOne}${labels?.conciled?.[languageObj?.id]}`)}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            <div className='col-md-12'>
                                                {/* {showData ? */}
                                                <div>
                                                    <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                        <table id={dtPaymentsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                    </div>
                                                </div>
                                                {/* : */}
                                                {/* <div></div> */}
                                                {/* } */}
                                            </div>
                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={globalSettings?.colors?.infoColorExp}
                                                    msgText={messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} />} */}
                                        </div>

                                    </div>
                                </div>

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>{/* /.content */}

            </div>

            {paymentShowModal ?
                <ReconciliePaymentEditDetails $={$}
                    auth={auth}
                    buildingBalance={buildingBalance}
                    setBuildingBalance={setBuildingBalance}
                    headerSectionValues={headerSectionValues}
                    setHeaderSectionValues={setHeaderSectionValues}
                    apartment={apartment}
                    payment={payment}
                    setPayment={setPayment}
                    paymentBeforeEdit={paymentBeforeEdit}
                    dtPaymentsId={dtPaymentsId}
                    paymentMethodDescription={paymentMethodDescription}
                    collectionCashes={collectionCashes}
                    bankDescriptionOrigin={bankDescriptionOrigin}
                    bankDescriptionDestiny={bankDescriptionDestiny}
                    bankAccountNumber={bankAccountNumber}
                    userConciliation={userConciliation}
                    paymentsGetAsync={paymentsGetAsync}
                    rowIndex={dtPaymentsRowIndex}
                    showModal={paymentShowModal}
                    setShowModal={setPaymentShowModal}
                    processTypeWindow={processTypeWindow}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}